import { SprocketIcon } from 'foundations-assets/icons/components/SprocketIcon';
import { jsx as _jsx } from "react/jsx-runtime";
function HubSpotIcon() {
  return /*#__PURE__*/_jsx(SprocketIcon, {
    color: "fill-accent-light-orange-default",
    size: "800"
  });
}
export default HubSpotIcon;